import { render, staticRenderFns } from "./serviceAgreementFengchao.vue?vue&type=template&id=0174c1ba&scoped=true&"
import script from "./serviceAgreementFengchao.vue?vue&type=script&lang=js&"
export * from "./serviceAgreementFengchao.vue?vue&type=script&lang=js&"
import style0 from "./serviceAgreementFengchao.vue?vue&type=style&index=0&id=0174c1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0174c1ba",
  null
  
)

export default component.exports